import type { UseQueryOptions, UseQueryResult } from "react-query";
import { useQuery } from "react-query";

import type { GetHealthReportsV2Args, GetHealthReportsV2Response } from "api/types/GetHealthReportsV2Response";
import { useApiClient } from "api/useApiClient";

type QueryKey = ["GetHealthReportsV2", GetHealthReportsV2Args];
export const getHealthReportsV2QueryKey = (args: GetHealthReportsV2Args): QueryKey => ["GetHealthReportsV2", args];

export const useGetHealthReportsV2Query = (
  args: GetHealthReportsV2Args,
  options?: UseQueryOptions<GetHealthReportsV2Response, Error, GetHealthReportsV2Response, QueryKey>
): UseQueryResult<GetHealthReportsV2Response, Error> => {
  const client = useApiClient();

  return useQuery(getHealthReportsV2QueryKey(args), () => client.getHealthReportsV2(args), options);
};
